<template>
<svg data-svg-lvl-3="edge-top-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Крышки_Подложка"><path class="tb-c-2" d="M58.6085,243.6347l-.0096.0047c.0039.0002.0083.0003.0122.0005l-.0026-.0053Z"/><path class="tb-c-2" d="M58.5989,243.6394c-.0921-.0048-.1838-.0125-.2757-.0185l.0609.124.2147-.1055Z"/><path class="tb-c-2" d="M49.5383,198.577c-12.6722,6.2261-18.0587,21.2189-12.0311,33.487,4.2377,8.6251,12.9894,13.5998,22.2166,13.6351l-.2377-.4838-.0814.04-.7937-1.6154c-.0039-.0002-.0083-.0003-.0122-.0005l-.2147.1055-.0609-.124c-7.9294-.5201-15.282-5.006-18.9508-12.4733-5.5378-11.2712-.5889-25.0452,11.053-30.7651,5.638-2.7701,11.8104-3.1369,17.3083-1.5049l2.5944-1.2747c-6.4455-2.5009-13.9765-2.3735-20.7898.9741Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.tb-c-1{opacity:.3;}.tb-c-2{fill:#232728;}.tb-c-2,.tb-c-3{stroke-width:0px;}.tb-c-3{fill:#64ff00;}</style>

